module.exports = __webpack_public_path__ + "static/media/BookReviewThumbnails.975412a0.jpg";